"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var constants_1 = require("./constants");
var ConfigHandler = (function () {
    function ConfigHandler(options) {
        if (options.enableSandboxMode) {
            this.apiBaseUrl = constants_1.SANDBOX_BASE_URL;
            this.cardConnectBaseUrl = constants_1.SANDBOX_CARD_CONNECT_BASE_URL;
            this.applePayUrl = constants_1.SANDBOX_APPLE_PAY_URL;
        }
        else {
            this.apiBaseUrl = constants_1.PRODUCTION_BASE_URL;
            this.cardConnectBaseUrl = constants_1.PRODUCTION_CARD_CONNECT_BASE_URL;
            this.applePayUrl = constants_1.APPLE_PAY_URL;
        }
        if (options.overrideBaseUrl) {
            this.apiBaseUrl = options.overrideBaseUrl;
        }
        this.authApiBaseUrl =
            options.overrideAuthApiBaseUrl || this.apiBaseUrl + "/auth";
        this.donorApiBaseUrl =
            options.overrideDonorApiBaseUrl || this.apiBaseUrl + "/donor";
        this.embedApiBaseUrl =
            options.overrideEmbedApiBaseUrl || this.apiBaseUrl + "/embed";
        if (options.overrideApplePayUrl) {
            this.applePayUrl = options.overrideApplePayUrl;
        }
        this.pcScriptBase = options.pcScriptBase || constants_1.FALLBACK_PC_SCRIPT_URL;
        this.pcScriptId = options.pcScriptId || constants_1.FALLBACK_PC_SCRIPT_ID;
        this.turnstileCdnUrl = options.turnstileCdnUrl || constants_1.DEFAULT_CF_TURNSTILE_CDN_EXPLICIT_URL;
        this.turnstileSiteKey = options.turnstileSiteKey || constants_1.FALLBACK_CF_TURNSTILE_SITE_KEY;
        if (options === null || options === void 0 ? void 0 : options.spreedlyEnvironmentKey) {
            this.spreedlyEnvironmentKey = options.spreedlyEnvironmentKey;
        }
        this.enableDelay = options.enableDelay || false;
        this.secondsToDelay = options.secondsToDelay || 0;
        this.cardConnectTokenizerUrl = this.cardConnectBaseUrl + "/itoke/ajax-tokenizer.html";
    }
    return ConfigHandler;
}());
exports.default = ConfigHandler;
